import axios from 'axios'
import store from '../store'
import router from '../router'
import i18n from "../locales";
import {getCurrentAccessToken, removeCurrentAccessToken} from "../utils/auth";

var api = axios.create({
    baseURL: window.location.origin + '/api/call-parking-wallboard/',
    withCredentials: false,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
})

var errorHandler = (error) => {
    if (error.response.status === 401) {
        router.currentRoute.meta.requiresAuth ? router.push('/login') : ''
        removeCurrentAccessToken()
    }

    if ([400, 402, 404, 406].includes(error.response.status)) {
        let message = ""
        if (error.response.data.code?.length) {
            message += i18n.t('alert-messages.error-occure-with-code') + error.response.data.code + " \n"
        }

        message += i18n.te('api-messages.' + error.response.data.error_message) ? i18n.t('api-messages.' + error.response.data.error_message) : error.response.data.error_message

        store.dispatch('createAlertMessage', {message: message, type: 'warning'})
    }

    if (error.response.status === 500) {
        store.dispatch('createAlertMessage', {message: i18n.t('alert-messages.something-went-wrong'), type: 'error'})
    }
    return Promise.reject(error);
}

api.interceptors.request.use(function (config) {
    const token = getCurrentAccessToken()
    if (token) {
        config.headers['X-AUTH-TOKEN'] = token
    }

    return config
});

api.interceptors.response.use(
    response => response,
    error => errorHandler(error)
)

export default () => {
    return api
}
